<p class="title h4">Monitor</p>
<div class="row" *ngIf="data">
  <div class="col">
    <div class="row">
      <p> GPC frontend, versione {{data.frontendVersion}}, rilasciata il {{data.feLastReleaseDate | date:'dd/MM/yyyy'}}</p> 
    </div>
    <div class="row">
      <p> GPC backend, versione: {{data.backendVersion}}, rilasciata il {{data.beLastReleaseDate | date:'dd/MM/yyyy'}}</p> 
    </div>
    <div class="row mb-3">
      <b>Integrazioni:</b>
    </div>
    <div class="row" *ngFor="let externalSystem of data.externalSystems">
      <p>{{externalSystem.description}}, versione {{externalSystem.version}}, attore connesso {{externalSystem.name}}, integrazione attiva: {{externalSystem.integrationActive}}</p> 
    </div>
  </div>
</div>
<div class="row" *ngIf="!data">
  <div class="col">
    <b>Impossibile caricare le informazioni</b>
  </div>
</div>